<template>
  <div>
    <v-alert
      v-show="newNotify.isNewNotify"
      border="left"
      close-text="Close Alert"
      color="blue accent-4"
      dark
      @click="fecharNotificacao"
    >
      {{ newNotify.text }}
    </v-alert>
    
    <v-autocomplete
      label="Selecionar Unidade"
      :items="listEndereco"
      v-model="enderecoSelecionado"
    >
    </v-autocomplete>

    <v-card v-if="enderecoSelecionado">
      <v-autocomplete
      v-model="subEstoqueSelecionado"
      :items="listaSubEstoque"
      v-if="listaSubEstoque.length > 1"
      label="Selecionar Estoque"
      >
      </v-autocomplete>
      <v-card-title>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="tableItens"
        :search="search"
        class="elevation-1"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>{{ tableTitle }}</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-btn @click="gerarEXCEL(tableItens)">IMPRIMIR ESTOQUE</v-btn>
            <v-dialog v-model="dialog" persistent>
              <v-progress-linear
                :active="isLoadingRequestDisable"
                indeterminate
                color="green accent-4"
                height="7"
              ></v-progress-linear>
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col
                        v-for="(fieldForm, i) in modalFormComposition"
                        :key="i"
                        :cols="fieldForm.size"
                        :sm="fieldForm.size"
                        :md="fieldForm.size"
                      >
                        <v-text-field
                          :label="fieldForm.title"
                          v-if="
                            fieldForm.type == 'text' ||
                            fieldForm.type == 'number'
                          "
                          v-model="editedItem[fieldForm.modelName]"
                        ></v-text-field>

                        <span v-if="fieldForm.type == 'date'">{{
                          fieldForm.title
                        }}</span>
                        <br />
                        <input
                          type="date"
                          v-if="fieldForm.type == 'date'"
                          v-model="editedItem[fieldForm.modelName]"
                          pattern="[0-9]{4}-[0-9]{2}-[0-9]{2}"
                        />
                        <!--<v-date-picker  v-if="fieldForm.type == 'date'" v-model="editedItem[fieldForm.modelName]" pattern="[0-9]{4}-[0-9]{2}-[0-9]{2}"></v-date-picker>--->
                        <v-select
                          v-if="fieldForm.type == 'select'"
                          :label="fieldForm.title"
                          :items="listsOptions[fieldForm.modelName]"
                          v-model="editedItem['numero' + fieldForm.modelName]"
                          append-outer-icon="mdi-plus-thick"
                          @click:append-outer="openPage(fieldForm.externalPage)"
                        >
                        </v-select>

                        <v-file-input
                          v-if="fieldForm.type == 'file'"
                          v-model="editedItem[fieldForm.modelName]"
                          placeholder="Documento"
                          :label="fieldForm.title"
                          prepend-icon="mdi-paperclip"
                          @change="uploadXML($event)"
                        >
                          <template v-slot:selection="{ text }">
                            <v-chip small label color="primary">
                              {{ text }}
                            </v-chip>
                          </template>
                        </v-file-input>
                      </v-col>
                      <div id="preview">
                        <img
                          v-if="editedItem['Base64ImagemItem']"
                          v-bind:src="
                            'data:image/png;base64,' +
                            editedItem['Base64ImagemItem']
                          "
                        />
                      </div>
                      <div id="preview">
                        <img
                          v-if="editedItem['Base64ImagemNota']"
                          v-bind:src="
                            'data:image/png;base64,' +
                            editedItem['Base64ImagemNota']
                          "
                        />
                      </div>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="grey darken-4"
                    text
                    :disabled="isModalButtonDisabled"
                    @click="closeModal"
                    >Fechar</v-btn
                  >
                  <v-btn
                    color="green darken-1"
                    text
                    :disabled="isModalButtonDisabled"
                    @click="insert"
                    v-if="!isEdition"
                    >Concluir</v-btn
                  >
                  <v-btn
                    color="green darken-1"
                    text
                    :disabled="isModalButtonDisabled"
                    @click="update"
                    v-if="isEdition"
                    >Concluir</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:[`item.quantidadeTotalEmEstoque`]="{ item }">
          <v-chip
            :color="getColor(item.quantidadeTotal, item.quantidadeAtual).color"
            dark
            >{{ item.quantidadeTotalEmEstoque }}</v-chip
          >
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <div v-if="getColor(item.quantidadeTotal, item.quantidadeAtual)">
            <v-tooltip
              v-if="
                getColor(item.quantidadeTotal, item.quantidadeAtual)
                  .isSolicitacao
              "
              bottom
            >
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  small
                  class="mr-2"
                  @click="emitDataTableSolicitRowEvent(item)"
                  v-bind="attrs"
                  v-on="on"
                  >mdi-alert-circle</v-icon
                >
              </template>
              <span>Solicitar Material</span>
            </v-tooltip>
          </div>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                small
                class="mr-2"
                @click="editItem(item)"
                v-bind="attrs"
                v-on="on"
              >
                mdi-pencil</v-icon
              >
            </template>
            <span>Editar</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small @click="deleteItem(item)" v-bind="attrs" v-on="on">
                mdi-delete
              </v-icon>
            </template>
            <span>Excluir</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { TheMask } from "vue-the-mask";
import store from "@/store/index";
import axios from "../plugins/axios";
import { Workbook } from 'exceljs'
import { saveAs } from 'file-saver';

export default {
 

  props: {
    classTitle: String, // Titulo da classe que estamos recebendo
    tableTitle: String, // Titulo da tabela que vamos mostrar
    newRowButtonText: String, // Texto do botão 'Novo'
    tableHeader: Array, // Configurações da Tabela
    tableData: Array, // Conteudo da tabela
    modalFormComposition: Array, // Formulário da modal
    onUpdate: Function, // Função que atualiza os dados da tabela
    onInsert: Function, // Função que insere o item no banco
    onDelete: Function, // Função de delata o item do banco
    onUpdateDataTable: Function, // Função que popula a tabela
    onUpdateoptions: Function, //
    isLoadingRequestDisable: Boolean, // Função que habilita e desabilita LoadingRequest
    newRowmodalButtonText: String, //Nome do botão
  },

  directives: { TheMask },

  watch: {
    subEstoqueSelecionado(){
      this.initialize()
     
    },
    enderecoSelecionado() {
      this.initialize();
    },
    editedItem() {},
  },

  data: function () {
    return {
        config: {
      headers: {
        "Content-Type": "application/json",
        "x-auth-token": store.state.token,
      },
    },
      subEstoqueSelecionado: null,
      listaSubEstoque: [],
      newNotify: {
        isNewNotify: false,
        text: "",
      },

      imgB64NotaFiscal: "",
      imgB64NotaFotoItem: "",
      urlImg: null,
      urlImg2: null,
      search: "",
      dialog: false,
      dialog3: false,
      menu2: false,
      headers: this.tableHeader,
      tableItens: [],
      listsOptions: [],
      isEdition: false,
      isModalButtonDisabled: false,
      editedItem: {},
      defaultItem: {},
      excluirItem: {},
      listEndereco: [],
      enderecoSelecionado: null,
      listItenUpload: [],
      listItenUploadNew: [],
    };
  },

  computed: {
    formTitle() {
      return !this.isEdition ? this.tableTitle : "Editar " + this.tableTitle;
    },
    computedDateFormatted() {
      return this.formatDate(this.date);
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    async listOfEndereco() {
      const config = {
        headers: {
          "Content-Type": "application/json",
          "x-auth-token": store.state.token,
        },
      };
      const responseEnderecos = await axios.get("enderecoordemservico", config);
      this.listEndereco = responseEnderecos.data.map((row) => {
        return {
          value: row.numeroEnderecoOrdemServico,
          text: row.nomeEndereco,
        };
      });
    },

    async uploadXML(e) {
      if (e) {
        this.imgB64NotaFotoItem = await this.getXML(e);
        let obj = await this.parseFile(this.imgB64NotaFotoItem);
        this.listItenUpload = obj.getElementsByTagName("prod");

        for (let i = 0; i < this.listItenUpload.length; i++) {
          this.listItenUploadNew.push(
            new Object({
              codigoProduto: this.listItenUpload[i].childNodes[0].innerHTML,
              nomeProduto: this.listItenUpload[i].childNodes[2].innerHTML,
              unidadeMedida: this.listItenUpload[i].childNodes[11].innerHTML,
              quantidadeItem: this.listItenUpload[i].childNodes[12].innerHTML,
            })
          );
        }

        //  for (const [i, value] of this.listItenUpload.entries()) {}
      } else {
        this.urlImg = null;
      }
    },

    async parseFile(file) {
      let doc = new DOMParser().parseFromString(file, "text/xml");

      return doc;
    },

    //   async getXML(file){
    //       let input = file.target
    //       let reader = new FileReader()
    //       let onload = function(file){
    //           text = reader.result
    //           parseFile(text)
    //       }
    //     reader.onload = onload;
    //     reader.readAsText(input.files[0])
    //   },

    async getXML(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsText(file);

        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },

    fecharNotificacao() {
      this.newNotify.isNewNotify = false;
    },

    getColor(total, atual) {
      let perc = ((atual / total) * 100).toFixed(3);
      if (perc >= 30) {
        const Option = {
          color: "green",
          isSolicitacao: false,
        };

        return Option;
      }
      if (perc < 30 && perc > 0) {
        const Option = {
          color: "orange",
          isSolicitacao: true,
        };

        return Option;
      }
      if (perc < 0) {
        const Option = {
          color: "red",
          isSolicitacao: true,
        };

        return Option;
      }
      if (atual == 0) {
        const Option = {
          color: "back",
          isSolicitacao: true,
        };
        return Option;
      }
      return {
        color: "green",
        isSolicitacao: true
      }
    },
    async initialize() {
      try {


        await this.listOfEndereco();
        this.setDefaultItens();
        if (this.enderecoSelecionado) {

          
        const buscarSubEstoque = await axios.put("subestoque", {numeroEndereco: this.enderecoSelecionado}, this.config)
        this.listaSubEstoque = buscarSubEstoque.data.map(function(subEstoque){
          return {
            text: subEstoque.nomeSubestoque,
            value: subEstoque.numeroSubestoque
          }
        })

          this.tableItens = await this.onUpdateDataTable(
            this.enderecoSelecionado, this.subEstoqueSelecionado
          );
          for (let fieldForm of this.modalFormComposition) {
            if (fieldForm.type == "select") {
              this.listsOptions[
                fieldForm.modelName
              ] = await this.onUpdateoptions(fieldForm.modelName);
            }
          }
        }
      } catch (error) {
        console.log(error);
      }
    },

    openPage(page) {
      this.$router.push(page);
    },

    async updataTable() {
      try {
        this.tableItens = await this.onUpdateDataTable();
      } catch (error) {
        console.log(error);
      }
    },

    editItem(item) {
      this.isEdition = true;
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    closeModal() {
      this.editedItem = Object.assign({}, []);
      this.isEdition = false;

      this.dialog = false;
    },

    setDefaultItens() {
      this.modalFormComposition.forEach((fieldForm) => {
        if (fieldForm.type == "select") {
          this.listsOptions[fieldForm.modelName] = "";
        }
        if (fieldForm.type == "number") {
          this.defaultItem[fieldForm.modelName] = "";
          this.excluirItem[fieldForm.modelName] = "";
        }
        if (fieldForm.type == "date") {
          this.defaultItem[fieldForm.modelName] = "";
        } else {
          this.defaultItem[fieldForm.modelName] = "";
          this.excluirItem[fieldForm.modelName] = "";
        }
      });
      this.excluirItem["numero" + this.classTitle];
    },

    gerarEXCEL(listaMaterial) {
      try {
        const workbook = new Workbook()
        var worksheet = workbook.addWorksheet("Materiais em Estoque", { views:[ { showGridLines: false } ]})

        worksheet.columns = [
            { key: 'col1', width: 25 },
            { key: 'col2', width: 25 },
            { key: 'col3', width: 70 },
            { key: 'col4', width: 25 },
            { key: 'col5', width: 30 }
        ];

        const linhaTitulos = worksheet.addRow({
          col1: 'ID',
          col2: 'Lote',
          col3: 'Item',
          col4: 'Validade',
          col5: 'Quantidade Total em Estoque'
        })
        linhaTitulos.font = { bold: true };

        listaMaterial.map((materialSelecionado) => {
          
          worksheet.addRow({
            col1: materialSelecionado.numeroItemUnidade,
            col2: materialSelecionado.lote,
            col3: materialSelecionado.nomeItem,
            col4: materialSelecionado.validade,
            col5: materialSelecionado.quantidadeTotalEmEstoque
          }).alignment = { vertical: 'top', horizontal: 'left' };

        })

        //STYLE BORDER
        var borderStyles = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" }
        };
        
        worksheet.eachRow({ includeEmpty: true }, function(row) {
          row.eachCell({ includeEmpty: true }, function(cell) {
            cell.border = borderStyles;
          });
        });

        workbook.xlsx.writeBuffer().then(function(data) {
          var blob = new Blob([data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          });
          saveAs(blob, "materiais-em-estoque.xlsx");
        });
      } catch (error) {
        console.log(error)
      }
    },

    async insert() {
      //   try {
      //     this.isModalButtonDisabled = true
      //     const item = await this.editedItem
      //     if(this.imgB64NotaFiscal){
      //       item['imgB64NotaFiscal'] = this.imgB64NotaFiscal
      //     }
      //      if(this.imgB64NotaFotoItem){
      //        item['imgB64ImagemItem'] = this.imgB64NotaFotoItem
      //     }

      //     await this.onInsert(item)
      //     this.updataTable()
      //    } catch (error) {
      //      console.log(error)
      //    } finally{
      //     this.isModalButtonDisabled = false
      //     this.closeModal()
      //  }
    },

    async update() {
      try {
        this.isModalButtonDisabled = true;
        const item = await this.editedItem;
        if (this.imgB64NotaFiscal) {
          item["imgB64NotaFiscal"] = this.imgB64NotaFiscal;
        }
        if (this.imgB64NotaFotoItem) {
          item["imgB64ImagemItem"] = this.imgB64NotaFotoItem;
        }
        await this.onUpdate(item);
        this.updataTable();
      } catch (error) {
        console.log(error);
      } finally {
        this.isModalButtonDisabled = false;
        this.closeModal();
      }
    },
    async deleteItem(item) {
      if (confirm("Tem certeza que deseja deletar esse material em estoque?")) {
        this.excluirItem["numero" + this.classTitle] = await item[
          "numero" + this.classTitle
        ];
        try {
          await this.onDelete(item);
          this.updataTable();
        } catch (error) {
          console.log(error);
        }
      }
    },
  },
};
</script>
<style scoped>
#preview {
  display: flex;
  justify-content: center;
  align-items: center;
}

#preview img {
  max-width: 100%;
  max-height: 500px;
}
</style>